export const DiamondMark = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round">
      <path d="M32 6 L54 24 L32 58 L10 24 Z" />
      <path d="M10 24 H54" />
      <path d="M32 6 L22 24 L32 58" />
      <path d="M32 6 L42 24 L32 58" />
    </g>
  </svg>
);
